function isObject(item: unknown): unknown {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function mergeDeep(target: any, ...sources: any[]) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export function mergeObjects<T extends object>(...sources: T[]): T {
  return sources.reduce<T>((acc: any, source: T) => {
    for (const [key, value] of Object.entries(source)) {
      if (!Array.isArray(value)) continue;

      acc[key] = acc[key] ? [...acc[key], ...value] : [...value];
    }
    return acc;
  }, {} as T);
}
